export const ACTION_TYPES = {
	SET_STATE: "Set_State",
	APP_INIT: "Initialize_Applications",
	APP_CLICK: "Application_Click",
	MINIMIZE: "Minimize",
	MAXIMIZE: "Maximize",
	CLOSE: "Close",
	TOGGLE_WIFI: "Toggle_Wifi",
	TOGGLE_AIRPLANE_MODE: "Toggle_Airplane_Mode",
	TOGGLE_MUTE: "Toggle_Mute",
	CHANGE_WALLPAPER: "Change_Wallpaper",
};

export const SCREENS = {
	DESKTOP: "Desktop",
	LOCK_SCREEN: "Lock_Screen",
	SHUT_DOWN: "Shut_Down",
};

export const ANALYTICS_EVENTS = {
	DOWNLOAD_RESUME: "Download_Resume",
	SEND_MAIL: "Send_Mail",
	CHANGE_POWER_STATE: "Chnage_Power_State",
	ADMIN: "Admin",
	BACKGROUND_CHANGE: "Background_Change",
	SOCIAL_CLICK: "Social_Click",
};
